import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
    const [menuVisible, setMenuVisible] = useState(false);
    const location = useLocation();
    const sys = location.pathname.split("/").at(-1);

    let cicPage = sys !== "fuerzadelta" ? `cic${sys}.travel` : `${sys}.net`;

    const toggleMenu = () => {
        setMenuVisible(!menuVisible);
    };

    return (
        <header id="WebPage_header" className="scrol">
            <nav className="navbar navbar-expand-lg backgroundDark navbar-dark fixed-top p-1 py-2">
                <a rel="noreferrer" className="navbar-brand ml-5 mr-5" href={`https://www.${cicPage}/public/default.aspx`}>
                    <img alt="img" src="/cicLogoBlanco.svg" width="80px" className="d-block" />
                </a>
                <button className="navbar-toggler collapsed" type="button" data-toggle="collapse" data-target="#navbarCollapse"
                    aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon text-white"></span>
                </button>
                {/* <div className="navbar-collapse collapse" id="navbarCollapse">
                    <ul className="navbar-nav align-items-center mr-auto">
                        <li className="nav-item mr-0 mr-sm-5">
                            <a rel="noreferrer" className="nav-link d-flex flex-column align-items-center" href={`https://www.${cicPage}/public/Contactanos.aspx`}title="Contactanos">
                                <img alt="img" src="/contactIcon.png" className="iconMenuH d-block" /> Contáctanos
                            </a>
                        </li>
                        <li className="nav-item mr-0 mr-sm-5">
                            <a rel="noreferrer" className="nav-link d-flex flex-column align-items-center" target="_blank" title="Flyers"
                                href="https://sites.google.com/cic.travel/ofertasciccolombia/caribe">
                                <img alt="img" src="/flyersIcon.png" className="iconMenuH d-block" /> Flyers
                            </a>
                        </li>
                        <li className="nav-item mr-0 mr-sm-5">
                            <a rel="noreferrer" className="nav-link d-flex flex-column align-items-center" href="https://formulariogrupos.cic.travel/"
                                target="_blank" title="Cotizar Grupo">
                                <img alt="img" src="/grupos.png" className="iconMenuH d-block" /> Cotizar Grupo
                            </a>
                        </li>
                        <li className="nav-item mr-0 mr-sm-5">
                            <a rel="noreferrer" className="nav-link d-flex flex-column align-items-center" title="Seguimiento"
                                href="https://notificaciones.cic.travel/Colombia_desk.html" target="_blank">
                                <img alt="img" src="/megaphoneIcon.png" style={{ filter: "brightness(0) invert(1) grayscale(1)" }} className="d-block"
                                    width="40px" /> Corneta
                            </a>
                        </li>
                        <li className="nav-item mr-0 mr-sm-5">
                            <a rel="noreferrer" className="nav-link d-flex flex-column align-items-center" title="WhatsApp"
                                href="https://api.whatsapp.com/send?phone=573183976776&amp;text=Hola!%20Necesito%20ayuda"
                                target="_blank">
                                <img alt="img" src="/wspIcon.png" className="d-block" width="90px" />
                            </a>
                        </li>
                    </ul>
                    <div className="d-flex justify-content-center flex-row mr-auto mr-md-5">
                        <div>
                            <img alt="img" src="/alert-blanco.svg" style={{ padding: "0.5em 0.5em 0 0", height: "2.5rem", marginLeft: "-4px" }} />
                        </div>
                        <div>
                            <span className="textNarrowCIC">
                                <span>Call Center: (+57)3009133376</span>
                                <br />
                                <span>Lun a Vie de 8:00 a 18:00.</span>
                                <br />
                                <span>Sáb 9:00 a 12:00.</span>
                            </span>
                        </div>
                    </div>
                    <div className="text-right">
                        <button className="btn bg-transparent shadow-none" type="button" id="dropdownMenuButton" onClick={toggleMenu}>
                            <img alt="img" src="/legal.png" width="60px" />
                        </button>
                        <div className={`menu-content text-center legalDropdown position-absolute pb-5 px-1 text-right backgroundDark bg-transparent ${menuVisible ? 'fade-in' : 'fade-out'}`}
                            id="menuItems">
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" href="https://www.ciccolombia.travel/public/LaEmpresa.aspx">
                                    <img alt="img" src="/businessIcon.svg" width="30px" className="d-block" />
                                    <span>Nuestra empresa</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="http://www.ciccolombia.travel/images/FILE/FILE/POLITICADETRATAMIENTODEDATOSCICCOLOMBIATRAVELSAS002.pdf">
                                    <img alt="img" src="/padLock.svg" width="30px" className="d-block" />
                                    <span>Política de Protección de datos</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="https://drive.google.com/open?id=0B5vlnSmsuGtvQ2s3ZjRhd1otLWU2OE5vS05KcDg0ZXpxbUVz">
                                    <img alt="img" src="/check.svg" width="30px" className="d-block" />
                                    <span>Certificación Evalcom SAS</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="https://drive.google.com/open?id=0B5vlnSmsuGtvYTdnUC1Ya0l0T1ozRlNvaHRGeXRXS3R2Wk1Z">
                                    <img alt="img" src="/lawHammer.svg" width="30px" className="d-block" />
                                    <span>Ley de retracto</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="http://www.ciccolombia.travel/images/FILE/FILE/CIC_Sostenibilidad.pdf">
                                    <img alt="img" src="/leafIcon.svg" width="30px" className="d-block" />
                                    <span>Políticas de Sostenibilidad</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="http://www.ciccolombia.travel/images/FILE/FILE/serecibedolar.pdf">
                                    <img alt="img" src="/moneyIcon.svg" width="30px" className="d-block" />
                                    <span>Politica de Pagos en Moneda Extranjera</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" target="_blank"
                                    href="https://docs.google.com/forms/d/e/1FAIpQLSd48nBGuUUzabill7pJaEOQjt8gsGfRg6pl3s_KiC6gnmo4eQ/viewform">
                                    <img alt="img" src="/groups.svg" width="30px" className="d-block" />
                                    <span>Trabaja con Nosotros</span>
                                </a>
                            </div>
                            <div>
                                <a rel="noreferrer" className="dropdownItem text-white d-flex flex-column align-items-center" href="https://www.ciccolombia.travel/public/Clausulas.aspx">
                                    <img alt="img" src="/legalDocument.svg" width="30px" className="d-block" />
                                    <span>Clausulas de Responsabilidad</span>
                                </a>
                            </div>
                        </div>
                    </div>
                </div> */}
            </nav>
        </header>
    )
}

export default Header;
